import { gql } from '@apollo/client/core';
import { Trans } from '@lingui/macro';
import React from 'react';
import useProduct from '../Product/useProduct';
import { Label, Value, Wrapper } from '../Base/DynamicComponent';

/**
 * @param {object} props
 * @param {object} [props.product|
 * @param {object} [props.style]
 * @param {...import('../Base/DynamicComponent').DynamicComponent} [props.rest]
 * @returns
 */
export default function Blend({ product: data, style, ...rest }) {
  const product = useProduct(data);
  if (!hasContent(product)) return null;
  return (
    <Wrapper style={style} {...rest}>
      <Label {...rest}>
        <Trans>Blend</Trans>
      </Label>
      <BlendValue product={data} {...rest} />
    </Wrapper>
  );
}

function BlendValue({ product: data, ...rest }) {
  const product = useProduct(data);
  if (!hasContent(product)) return null;
  return <Value {...rest}>{grapeVarietyString(product)}</Value>;
}

Blend.Value = BlendValue;

function grapeVarietyString({ grapeVarieties }) {
  return grapeVarieties
    ?.map(({ percentage, varietyName }) => {
      return percentage ? `${percentage}% ${varietyName}` : `${varietyName}`;
    })
    .join(', ');
}

Blend.hasContent = hasContent;

function hasContent({ grapeVarieties = [] }) {
  return grapeVarieties?.length > 0;
}

Blend.fragment = gql`
  fragment Blend on Product {
    ... on Wine {
      grapeVarieties {
        percentage
        varietyName
      }
    }
  }
`;
